import { ArrowDownIcon } from '@synergy/theme-next';
import { ReactElement } from 'react';
import { Select, SelectProps, styled } from '@mui/material';

export const StyledSelect = styled(Select)(({ theme, value }) => ({
    borderRadius: theme.spacing(2.5),
    height: theme.spacing(5),
    textOverflow: 'hidden',

    '& .MuiSelect-select': {
        borderColor: theme.palette.grey[400],

        paddingTop: theme.spacing(),
        paddingBottom: '9px',
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
    },

    '& .MuiOutlinedInput-input': {
        paddingRight: theme.spacing(5.3) + '!important',
    },

    ...(value !== 'undefined' && {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.common.black,
        },
    }),

    [theme.breakpoints.up('sm')]: {
        maxWidth: '326px',
    },
})) as unknown as typeof Select;

type FilterSelectProps<T> = SelectProps<T> & { active?: boolean };

export const FilterSelectBase = <T,>(props: FilterSelectProps<T>): ReactElement => (
    <StyledSelect<T>
        displayEmpty={true}
        IconComponent={ArrowDownIcon}
        MenuProps={{
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
        }}
        {...props}
    />
);
